const ENV_TYPE = "prod";
// "dev" | "prod"

const CONFIG = {
  dev: {
    API_BASE_URL: "http://localhost:3011/api",
  },

  prod: {
    API_BASE_URL: "https://api.johukumservices.com/api",
  },
};

export const ENV = CONFIG[ENV_TYPE];